/**
 *
 * Component: Upload
 * Date: 21/1/2021
 *
 */

import React from 'react';

import { Upload as CustomUpload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { UploadInterface } from './interfaces';

const { Dragger } = CustomUpload;

function Upload({ totalAudios, ...rest }: UploadInterface) {
  return (
    <Dragger {...rest}>
      {totalAudios ? (
        <div>
          {totalAudios}
          audio files selected
        </div>
      ) : (
        <>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            Click or drag files to this area to upload
          </p>
        </>
      )}
    </Dragger>
  );
}

export default Upload;
